import { ResultsPillarTextColumnType } from '@data/types';
import classNames from 'classnames';
import React from 'react';

import Button from './Button';
import Prose from './Prose';

interface Props extends ResultsPillarTextColumnType {}

const ResultsPillarTextColumn: React.FC<Props> = ({
  htmlContent,
  backgroundColour,
  button,
}) => {
  if (htmlContent.length < 1) return <></>;

  return (
    <div
      className={classNames(
        'results-pillar-text-column w-full bg-white rounded-tl-[2rem] rounded-br-[2rem] p-8 border border-solid border-grey-dark/[0.50] text-blue',
        {
          '!bg-blue !border-blue-light/[0.25] !text-white':
            backgroundColour === 'blue',
        }
      )}
    >
      <Prose
        htmlContent={htmlContent}
        className={classNames(
          'prose-p:text-sm prose-ol:text-sm prose-ul:text-sm prose-h3:!text-lg prose-h3:!leading-snug prose-h3:!mb-6 !text-sm max-w-full',
          [
            backgroundColour === 'blue'
              ? 'text-white prose-h3:text-white prose-a:text-white'
              : '!text-blue prose-h3:!text-blue prose-p:!text-blue',
          ],
          {}
        )}
      />
      {button && <Button {...button} target="_blank" />}
    </div>
  );
};

export default ResultsPillarTextColumn;
